import { loadingController, toastController } from '@ionic/vue';
import i18n from '@/plugins/i18n';

export default {
  methods: {
    /**
     * Handle request data with a loader and error handler
     *
     * @param {Function} callback
     * @param {Object} options
     */
    async handleRequest(callback, options = {}) {
      const loading = await loadingController.create(options);
      await loading.present();

      try {
        await callback((message) => {
          loading.message = message;
        });
      /* c8 ignore next 5 */
      } catch (e) {
        if (['development', 'test'].includes(process.env.NODE_ENV)) {
          console.error(e);
        }
        this.showErrorToast(e.message, i18n.global.t('error.header_api'));
      } finally {
        await loading.dismiss();
      }
    },
    /**
     * Show error toast
     *
     * @param {String} message
     * @param {String} header
     */
    /* c8 ignore next 11 */
    async showErrorToast(message, header) {
      const toast = await toastController
        .create({
          header,
          message,
          position: 'bottom',
          color: 'danger',
          duration: 10000,
        });
      await toast.present();
    },
  },
};
